import React from 'react';

import styles from './PrimaryButton.module.scss';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  /** Wrap the button in a sticky bottom bar with a gradient fade (default true) */
  sticky?: boolean;
  /** 'solid' gradient CTA (default) or 'ghost' translucent secondary */
  variant?: 'solid' | 'ghost';
  /** Optional secondary content rendered under the button inside the sticky bar */
  extra?: React.ReactNode;
  /** Slide the sticky bar out of view (used to show it only when the inline CTA is off-screen) */
  hidden?: boolean;
  /** Replace the label with a spinner and block clicks (e.g. while billing is still loading) */
  loading?: boolean;
};

export const PrimaryButton: React.FC<Props> = ({ children, onClick, disabled, sticky = true, variant = 'solid', extra, hidden, loading }) => {
  const button = (
    <button
      type="button"
      className={`${styles.btn} ${variant === 'ghost' ? styles.ghost : ''} ${loading ? styles.loading : ''}`}
      onClick={loading ? undefined : onClick}
      disabled={disabled}
      aria-busy={loading || undefined}
    >
      {loading ? <span className={styles.spinner} /> : children}
    </button>
  );

  if (!sticky) return button;
  return (
    <div className={`${styles.wrap} ${hidden ? styles.wrapHidden : ''}`}>
      {button}
      {extra}
    </div>
  );
};

export default PrimaryButton;
